var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addOnInfo } from '@content/products/extras';
import Flyout from '@marketing/components/funnel/Flyout';
import Accordion from '@marketing/components/funnel/Flyout/Accordion';
import ProductCard from '@marketing/components/funnel/ProductCard';
import { NewProduct, ProductImageNameAndPrice, TopPick, } from '@marketing/components/funnel/ProductCard/ProductCard';
import AAFCONutritionLabel from '@marketing/components/global/misc/AAFCONutritionLabel';
import { allProductInfos } from '@marketing/content';
import { useProfileContext } from '@marketing/profile/ProfileContext';
import { ProfileFormLayout, ProfileFormMain } from '@marketing/profile/common/ProfileFormLayout';
import { clsx } from 'clsx';
import { Fragment, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { getMaxNumPets, getRecommendedProduct, prioritizeProducts } from '../../utils';
import { OUT_OF_STOCK_PRODUCT_TYPES_PROFILE } from '@variables';
var ProductDetails = function (_a) {
    var isFlyoutOpen = _a.isFlyoutOpen, isTopPick = _a.isTopPick, product = _a.product, toggleOpen = _a.toggleOpen;
    var serverLoading = useProfileContext().serverLoading;
    var costCents = product.costCents, detailsList = product.detailsList, displayName = product.displayName, inactiveIngredients = product.inactiveIngredients, ingredients = product.ingredients, ingredientsList = product.ingredientsList, instructions = product.instructions, isNew = product.isNew, productType = product.productType, shopifyCostCents = product.shopifyCostCents;
    var cost = costCents / 100;
    var shopifyCost = shopifyCostCents / 100;
    var discount = Math.ceil((100 * (shopifyCost - cost)) / shopifyCost);
    return (_jsx(Flyout, __assign({ isOpen: isFlyoutOpen, onToggle: function () { return toggleOpen(product.key.name); } }, { children: _jsx("div", __assign({ className: "p-5 md:p-12" }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 gap-12 md:gap-16 mt-12" }, { children: [_jsxs("div", __assign({ className: "grid grid-cols-1 gap-4" }, { children: [_jsx(ProductImageNameAndPrice, { disabled: serverLoading, imageData: {
                                    src: allProductInfos[product.key.name].image.src,
                                    alt: allProductInfos[product.key.name].image.alt,
                                }, isFlyout: true, price: costCents / 100, fullPrice: discount ? shopifyCostCents / 100 : null, discount: discount, productId: product.key.name, productName: displayName, type: productType }), isTopPick ? _jsx(TopPick, { onCard: false }) : isNew ? _jsx(NewProduct, { onCard: false }) : null] })), _jsxs("div", { children: [_jsx(Accordion, __assign({ className: "py-4", title: "Details" }, { children: _jsx("ul", __assign({ className: "list-disc pl-6" }, { children: detailsList.map(function (detail, index) {
                                        return (_jsx("li", __assign({ className: "py-1" }, { children: detail }), "detail-".concat(index)));
                                    }) })) })), productType === 'treat' && (_jsx(Accordion, __assign({ className: "py-4", title: "Nutrition" }, { children: _jsx(AAFCONutritionLabel, { recipe: product.key.name, type: "treat" }) }))), _jsxs(Accordion, __assign({ className: "py-4", title: "Ingredients" }, { children: [productType === 'treat' && _jsx("p", { children: ingredients }), productType === 'probiotic' && (_jsxs("div", __assign({ className: "grid grid-cols-1 gap-8" }, { children: [_jsxs("div", { children: [_jsx("p", __assign({ className: "font-bold" }, { children: "Active Ingredients per scoop (2g):" })), _jsx("ul", { children: ingredientsList.map(function (row, index) {
                                                            return (_jsxs("li", __assign({ className: "flex gap-4 py-1 border-t" }, { children: [_jsxs("span", __assign({ className: "flex-1" }, { children: [index === 0 && (_jsx("span", __assign({ className: "block" }, { children: "Proprietary Probiotic Blend" }))), _jsx("span", __assign({ className: clsx(index === 0 && 'italic') }, { children: row.ingredient }))] })), _jsx("span", __assign({ className: "" }, { children: row.amount }))] }), "ingredient-".concat(row.ingredient)));
                                                        }) })] }), _jsx("hr", {}), _jsxs("div", { children: [_jsx("p", __assign({ className: "font-bold" }, { children: "Inactive ingredients:" })), _jsx("p", { children: inactiveIngredients })] })] })))] })), productType === 'probiotic' && (_jsx(Accordion, __assign({ className: "py-4", title: "Instructions" }, { children: instructions.map(function (_a) {
                                    var heading = _a.heading, description = _a.description;
                                    return (_jsxs("div", __assign({ className: "py-2" }, { children: [_jsx("p", __assign({ className: "font-bold" }, { children: heading })), _jsx("p", { children: description })] }), heading));
                                }) })))] })] })) })) })));
};
var AddOnsForm = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), currentPet = _a.currentPet, currentPetSurvey = _a.currentPetSurvey, profileData = _a.profileData, saveProfile = _a.saveProfile, serverLoading = _a.serverLoading, profileBasePath = _a.profileBasePath;
    var petAddOns = profileData.addOnProducts
        .filter(function (product) {
        return !product.adminOnly && !product.doNotDisplay && product.petTypes.includes(currentPet.petType);
    })
        .map(function (addOn) {
        return __assign(__assign({}, addOn), addOnInfo[addOn.key.name]);
    });
    var _b = useState(profileData.orderItems), addOns = _b[0], setAddOns = _b[1];
    var _c = useState(false), isFlyoutOpen = _c[0], setIsFlyoutExpanded = _c[1];
    var _d = useState(__assign(__assign({}, petAddOns[0]), addOnInfo[petAddOns[0].key.name])), clickedProduct = _d[0], setClickedProduct = _d[1];
    var recommendedProducts = useMemo(function () {
        var recommendedProducts = [];
        if (currentPetSurvey && currentPetSurvey.purchasingMotivations) {
            recommendedProducts = [
                getRecommendedProduct(profileData.orderItems, currentPet, currentPetSurvey),
            ];
        }
        return recommendedProducts;
    }, [currentPet, currentPetSurvey]);
    var toggleFlyout = function (productId) {
        setClickedProduct(function () {
            return __assign(__assign({}, petAddOns.find(function (addOn) { return addOn.key.name === productId; })), addOnInfo[productId]);
        });
        setIsFlyoutExpanded(function (prev) { return !prev; });
    };
    var handleSelectAddOn = function (productId, quantity, frequency) {
        if (addOns.find(function (addOn) { return addOn.productType === productId; })) {
            setAddOns(function (prev) { return prev.filter(function (addOn) { return addOn.productType !== productId; }); });
        }
        else {
            setAddOns(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                { productType: productId, units: quantity, isRecurring: frequency === 'everyorder' },
            ], false); });
        }
    };
    var handleQuantityChange = function (productId, quantity) {
        var changedAddOn = addOns.find(function (addOn) { return addOn.productType === productId; });
        if (changedAddOn) {
            setAddOns(function (prev) {
                return prev.map(function (addOn) {
                    return addOn.productType === productId ? __assign(__assign({}, changedAddOn), { units: quantity }) : addOn;
                });
            });
        }
    };
    var handleFrequencyChange = function (productId, frequency) {
        var changedAddOn = addOns.find(function (addOn) { return addOn.productType === productId; });
        if (changedAddOn) {
            setAddOns(function (prev) {
                return prev.map(function (addOn) {
                    return addOn.productType === productId
                        ? __assign(__assign({}, changedAddOn), { isRecurring: frequency === 'everyorder' }) : addOn;
                });
            });
        }
    };
    var handleClickPrevious = function () {
        var previousPath = profileData.pets.length === getMaxNumPets(profileData.version)
            ? "pet/".concat(profileData.pets.length - 1, "/meals")
            : 'add_another_dog';
        navigate("".concat(profileBasePath, "/").concat(previousPath), { viewTransition: true });
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, saveProfile({
                            orderItems: addOns,
                        })];
                case 2:
                    _a.sent();
                    navigate("".concat(profileBasePath, "/contact"), { viewTransition: true });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error saving profile:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var prioritizedAddons = prioritizeProducts(petAddOns, recommendedProducts);
    var formId = 'pet-addons-form';
    return (_jsxs(ProfileFormLayout, __assign({ formId: formId, handleClickPrevious: handleClickPrevious }, { children: [_jsx(ProfileFormMain, __assign({ h1: "Nom Nom Sign Up: Other Products Selections" }, { children: _jsxs("form", __assign({ id: formId, className: "grid grid-cols-1 gap-6 md:gap-10", onSubmit: handleSubmit }, { children: [_jsxs("div", __assign({ className: "text-center" }, { children: [_jsx("h2", __assign({ className: "font-medium" }, { children: "Other Products Selections" })), _jsx("p", { children: "Probiotics & Treats" })] })), _jsx("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-6 px-5 md:p-0" }, { children: prioritizedAddons.map(function (addOn) {
                                var addOnInCart = addOns.find(function (a) { return a.productType === addOn.key.name; });
                                var cost = addOn.costCents / 100;
                                var shopifyCost = addOn.shopifyCostCents / 100;
                                var discount = Math.ceil((100 * (shopifyCost - cost)) / shopifyCost);
                                var isOutOfStock = OUT_OF_STOCK_PRODUCT_TYPES_PROFILE.includes(addOn.key.name);
                                var _a = addOnInfo[addOn.key.name], displayName = _a.displayName, isNew = _a.isNew, productType = _a.productType;
                                return (_jsx(Fragment, { children: _jsx(ProductCard, { disabled: serverLoading || isOutOfStock, discount: discount, fullPrice: shopifyCost, handleFrequencyChange: handleFrequencyChange, handleQuantityChange: handleQuantityChange, handleSelectProduct: handleSelectAddOn, imageData: {
                                            src: allProductInfos[addOn.key.name].image.src,
                                            alt: allProductInfos[addOn.key.name].image.alt,
                                        }, initialFrequency: addOnInCart && addOnInCart.isRecurring ? 'everyorder' : 'onetime', initialQuantity: addOnInCart && addOnInCart.units, isOutOfStock: isOutOfStock, isTopPick: recommendedProducts.includes(addOn.key.name), isSelected: Boolean(addOns.find(function (a) { return a.productType === addOn.key.name; })), isNew: isNew, price: cost, productId: addOn.key.name, productName: displayName, toggleFlyout: toggleFlyout, tooltip: "Receive with every order or only one time", type: productType }) }, "addon-".concat(addOn.key.name)));
                            }) }))] })) })), _jsx(ProductDetails, { isFlyoutOpen: isFlyoutOpen, isTopPick: recommendedProducts.includes(clickedProduct.key.name), product: clickedProduct, toggleOpen: toggleFlyout })] })));
};
export default AddOnsForm;
